import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {RoleStatus} from "../../models/role-status";
import Helpers from "../../utils/helpers";

@Injectable()
export class RoleStatusControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getRoleStatus(roleStatusId: string) {
    return this.http.get(this.baseUrl + "role_status/" + roleStatusId);
  }

  public saveRoleFileValidatedStatus(roleStatusId: string, roleStatus: RoleStatus) {
    Helpers.trimRecursiveObj(roleStatus);
    const body = JSON.stringify(roleStatus);
    return this.http.put(this.baseUrl + "role_status/" + roleStatusId + "/file_validated_status", body, {responseType: "text"});
  }

  public saveRoleFileDeclineStatus(roleStatusId: string, roleStatus: RoleStatus) {
    Helpers.trimRecursiveObj(roleStatus);
    const body = JSON.stringify(roleStatus);
    return this.http.put(this.baseUrl + "role_status/" + roleStatusId + "/file_decline_status", body, {responseType: "text"});
  }

  public saveRoleFileRejectStatus(roleStatusId: string, roleStatus: RoleStatus) {
    Helpers.trimRecursiveObj(roleStatus);
    const body = JSON.stringify(roleStatus);
    return this.http.put(this.baseUrl + "role_status/" + roleStatusId + "/file_reject_status", body, {responseType: "text"});
  }

  public saveRoleUserDefinedStatus(roleStatusId: string, roleStatus: RoleStatus) {
    Helpers.trimRecursiveObj(roleStatus);
    const body = JSON.stringify(roleStatus);
    return this.http.put(this.baseUrl + "role_status/" + roleStatusId + "/user_defined_status", body, {responseType: "text"});
  }

  public createRoleFileValidatedStatus(roleId: string, roleStatus: RoleStatus) {
    Helpers.trimRecursiveObj(roleStatus);
    const body = JSON.stringify(roleStatus);
    return this.http.post(this.baseUrl + "role/" + roleId + "/role_status/file_validated_status", body);
  }

  public createRoleUserDefinedStatus(roleId: string, roleStatus: RoleStatus) {
    Helpers.trimRecursiveObj(roleStatus);
    const body = JSON.stringify(roleStatus);
    return this.http.post(this.baseUrl + "role/" + roleId + "/role_status/user_defined_status", body);
  }

  public deleteRoleStatus(roleStatusId: string) {
    return this.http.delete(this.baseUrl + "role_status/" + roleStatusId, {responseType: "text"});
  }

  public saveFilePendingStatus(roleStatusId: string, roleStatus: RoleStatus) {
    Helpers.trimRecursiveObj(roleStatus);
    const body = JSON.stringify(roleStatus);
    return this.http.put(this.baseUrl + "role_status/" + roleStatusId + "/file_pending_status", body, {responseType: "text"});
  }

}
